import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
    0% { background-position: -200px 0; }
    100% { background-position: calc(200px + 100%) 0; }
`;

const shimmerSurface = `
    background: linear-gradient(90deg, #e0e0e0 0%, #ededed 50%, #e0e0e0 100%);
    background-size: 200px 100%;
`;

export const SkeletonRoot = styled.div<{ $minHeight: number }>`
    width: 100%;
    min-height: ${({ $minHeight }) => $minHeight}px;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 24px;
    background-color: ${({ theme }) => theme.uiBricks?.priceHeaderBackgroundColor || '#f4f4f4'};
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SkeletonBar = styled.div<{ $width?: string; $height?: string }>`
    ${shimmerSurface}
    width: ${({ $width }) => $width ?? '100%'};
    height: ${({ $height }) => $height ?? '16px'};
    border-radius: 4px;
    animation: ${shimmer} 1.4s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const SkeletonBlock = styled.div`
    ${shimmerSurface}
    flex: 1;
    min-height: 0;
    border-radius: 16px;
    animation: ${shimmer} 1.4s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;
